import * as React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import LogRocket from 'logrocket';
import { Provider as AlertProvider } from 'react-alert';
import AlertTemplate from 'react-alert-template-basic';
import { initializeJobData } from '../data/jobs/jobActions';
import {
  Redirect,
  Switch,
  Route,
} from 'react-router-dom';
import AgencyList from './Agencies/AgencyList';
import JobLeads from './JobLeads';
import Dashboard from './Dashboard/Dashboard';
import JobPostings from './AgencyPostings/JobPostings';
import Titles from './Titles/Titles';
import OpenWeb from './OpenWeb/OpenWeb';
import OpenWebPromotion from './OWP/OpenWebPromotion';
import createLogger from '../utils/createLogger';

const DEBUG = false;
const debug = createLogger(DEBUG, `Jobs.js`);
const alertOptions = {
  position: 'bottom right',
  timeout: 5000,
  offset: '30px',
  transition: 'scale',
};

class Jobs extends React.Component {

  static propTypes = {
    match: PropTypes.object.isRequired,
    isAuthenticated: PropTypes.bool.isRequired,
    initializeJobData: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    debug.enter(`constructor`);
    let lr = false;

    if(props.isAuthenticated && props.authUser) {
        lr = true;
        LogRocket.identify(props.authUser);
    } 
    this.state = {
      logRocketIdent: lr,
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    debug.enter('componentDidUpdate')
    const { isAuthenticated, authUser } = this.props;
    const { logRocketIdent } = this.state;

    if(isAuthenticated && !logRocketIdent && authUser) {
        LogRocket.identify(authUser);
        this.setState({logRocketIdent: true});
    } else {
        debug.log(`cannot init logrocket identity ${isAuthenticated} and ${authUser}`);
    }

  };

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    debug.enter('shouldComponentUpdate');
    debug.log(nextProps, nextState, nextContext);
    return true;
  }

  /* ------------ render methods ------------ */
  render() {
    const {
      match,
      isAuthenticated,
    } = this.props;

    debug.enter(`render`);

    if (!isAuthenticated) {
      return <Redirect to="/auth"/>
    }

    return (
      <AlertProvider template={AlertTemplate} {...alertOptions}>
        <Switch>
          <Route exact path={match.url} component={JobPostings}/>
          <Route path={`${match.url}/leads`} component={JobLeads}/>
          <Route path={`${match.url}/titles`} component={Titles}/>
          <Route path={`${match.url}/openweb`} component={OpenWeb}/>
          <Route path={`${match.url}/owp`} component={OpenWebPromotion}/>
          <Route path={`${match.url}/dashboard`} component={Dashboard}/>
          <Route path={`${match.url}/agencies`} component={AgencyList}/>
        </Switch>
      </AlertProvider>
    );
  }
}

/* ------------ redux connect ------------ */
const mapStateToProps = (state) => {
  let user = null;
  if(state.auth && state.auth.session && state.auth.session.idTokenPayload) {
    user = state.auth.session.idTokenPayload.email || state.auth.session.idTokenPayload.name;
  } else {
    debug.log('jobs.js: no auth user - ', state.auth);
  }
  
  return {
    isAuthenticated: !!state.auth.session,
    authUser: user
  }
};

export default connect(mapStateToProps, {
  initializeJobData,
})(Jobs);



// WEBPACK FOOTER //
// ./src/components/Jobs.js